<div class="playlistpicker-container">
  <h1 mat-dialog-title>{{ (isNew ? 'playlistpicker.create' : 'playlistpicker.title') | translate }}</h1>

  <div mat-dialog-content>
    <mwo-item-selector *ngIf="!isNew" [itemList]="playlists$ | async" (itemSelected)="selectPlaylist($event)"></mwo-item-selector>
    <form class="playlistpicker-form" *ngIf="isNew">
      <mat-form-field>
        <input matInput placeholder="{{ 'playlistpicker.name' | translate }}" [(ngModel)]="name" name="playlistName" />
      </mat-form-field>
    </form>
  </div>

  <div mat-dialog-actions *ngIf="isNew">
    <button mat-button (click)="createPlaylist()" cdkFocusInitial>OK</button>
  </div>
</div>
